import { AUTH_LOGOUT } from '../../../../../common/redux/actions/types/authActionTypes';
import {
  EDIT_MRD_SETTINGS_FAILURE,
  EDIT_MRD_SETTINGS_REQUEST,
  EDIT_MRD_SETTINGS_SUCCESS,
} from '../actions/types/DeviceSettingsActionTypes';

export const initialState = {
  editDeviceSettingsLoading: false,
};

const DeviceSettingsReducer = (state = initialState, action) => {
  switch (action.type) {
  case EDIT_MRD_SETTINGS_REQUEST:
    return {
      ...state,
      editDeviceSettingsLoading: true,
    };
  case EDIT_MRD_SETTINGS_SUCCESS:
    return {
      ...state,
      editDeviceSettingsLoading: false,
    };
  case EDIT_MRD_SETTINGS_FAILURE:
    return {
      ...state,
      editDeviceSettingsLoading: false,
    };
  case AUTH_LOGOUT:
    return initialState;
  default:
    return state;
  }
};

export default DeviceSettingsReducer;
